// extracted by mini-css-extract-plugin
module.exports = {"colorItem":"ColorItem_colorItem__UwhuZ","colorItemBordered":"ColorItem_colorItemBordered__8tN8D","disabled":"ColorItem_disabled__PYFbN","crossIcon":"ColorItem_crossIcon__LUnfX"};